import { FormattedMessage, useIntl } from 'react-intl';

import type { SVGProps } from 'react';

/**
 * Illustration for the Scribe spotlight: audio waveform + Heidi mark above a
 * mock Transcript/Note document. Converted from the Figma export
 * (scribe-spotlight.svg) so the labels can be translated via react-intl.
 */
// theme-agnostic: fixed-palette Figma illustration, renders identically in both themes
export const ScribeSpotlightSvg = (props: SVGProps<SVGSVGElement>) => {
  const intl = useIntl();

  return (
    // direction="ltr": the artwork is composed left-to-right; without it, an
    // inherited dir="rtl" (Arabic) flips text-anchor's start side and every
    // label extends leftward from its authored x, clipping out of the canvas.
    <svg
      viewBox="0 0 793 460"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      direction="ltr"
      role="img"
      aria-label={intl.formatMessage({ defaultMessage: 'Illustration of a recording being turned into a transcript and note', id: '8dKqoIUrSq' })}
      {...props}
    >
      <g clipPath="url(#scribe-spotlight-clip)">
        <rect width="792.222" height="460" fill="#F9F4F1" />
        <path
          d="M249.167 115.15L249.167 92.4982C249.167 86.2432 254.237 81.1725 260.492 81.1725C266.747 81.1725 271.818 86.2432 271.818 92.4982L271.818 115.15C271.818 121.405 266.747 126.476 260.492 126.476C254.237 126.476 249.167 121.405 249.167 115.15Z"
          fill="#16A34A"
        />
        <path
          d="M283.183 128.354L283.183 79.2775C283.183 73.0225 288.254 67.9518 294.509 67.9518C300.764 67.9518 305.834 73.0225 305.834 79.2775L305.834 128.354C305.834 134.609 300.764 139.68 294.509 139.68C288.254 139.68 283.183 134.609 283.183 128.354Z"
          fill="#16A34A"
        />
        <path
          d="M317.199 145.346L317.199 62.2926C317.199 56.0375 322.269 50.9668 328.524 50.9668C334.78 50.9668 339.85 56.0375 339.85 62.2926L339.85 145.346C339.85 151.601 334.78 156.672 328.524 156.672C322.269 156.672 317.199 151.601 317.199 145.346Z"
          fill="#16A34A"
        />
        <path
          d="M351.215 134.963L351.215 72.6738C351.215 66.4187 356.286 61.348 362.541 61.348C368.796 61.348 373.866 66.4187 373.866 72.6738L373.866 134.963C373.866 141.218 368.796 146.288 362.541 146.288C356.286 146.288 351.215 141.218 351.215 134.963Z"
          fill="#16A34A"
        />
        <path
          d="M385.23 154.785L385.23 52.8536C385.23 46.5986 390.301 41.5278 396.556 41.5278C402.811 41.5278 407.881 46.5986 407.881 52.8536L407.881 154.785C407.881 161.04 402.811 166.111 396.556 166.111C390.301 166.111 385.23 161.04 385.23 154.785Z"
          fill="#16A34A"
        />
        <path
          d="M419.246 135.913L419.246 71.732C419.246 65.477 424.317 60.4062 430.572 60.4062C436.827 60.4062 441.898 65.477 441.898 71.732L441.898 135.913C441.897 142.167 436.826 147.239 430.572 147.239C424.318 147.239 419.247 142.167 419.246 135.913Z"
          fill="#16A34A"
        />
        <path
          d="M453.262 128.354L453.262 79.2775C453.262 73.0225 458.333 67.9518 464.588 67.9518C470.843 67.9518 475.914 73.0225 475.914 79.2775L475.914 128.354C475.914 134.609 470.843 139.68 464.588 139.68C458.333 139.68 453.262 134.609 453.262 128.354Z"
          fill="#16A34A"
        />
        <path
          d="M487.278 115.15L487.278 92.4982C487.278 86.2432 492.349 81.1725 498.604 81.1725C504.859 81.1725 509.93 86.2432 509.93 92.4982L509.93 115.15C509.93 121.405 504.859 126.476 498.604 126.476C492.349 126.476 487.278 121.405 487.278 115.15Z"
          fill="#16A34A"
        />
        <path
          d="M41.5278 104.248C41.5278 55.4946 81.0502 15.9722 129.804 15.9722C178.557 15.9722 218.079 55.4945 218.079 104.248V106.585C218.079 155.339 178.557 194.861 129.804 194.861C81.0502 194.861 41.5278 155.339 41.5278 106.585V104.248Z"
          fill="#4C2934"
        />
        <path
          d="M164.163 94.2895C160.227 95.3327 164.163 102.872 159.943 103.346C158.71 103.488 156.624 103.346 154.537 103.394C149.985 103.109 147.425 104.2 147.045 102.208C146.951 94.574 147.045 81.4868 147.045 74.7061C147.472 68.0202 145.575 60.9076 139.838 56.7823C130.686 49.5749 115.892 54.933 113.332 66.3132C111.53 77.3141 113.095 91.2074 112.526 102.208C112.241 104.342 107.452 103.062 105.034 103.394C98.6797 103.394 97.3046 104.389 97.352 97.6561C97.2571 95.7594 95.9294 93.6256 94.0328 94.7637C91.8041 96.8975 92.9896 101.497 92.7051 104.437C91.899 122.361 105.271 139.668 122.815 142.608C124.143 142.892 126.087 143.035 126.798 144.173C128.41 146.212 126.087 155.6 128.742 157.07C131.445 158.161 132.346 155.648 132.156 151.854C132.488 147.634 130.924 143.651 135.049 142.892C142.968 141.66 150.839 137.819 156.624 131.56C165.68 122.408 168.004 108.704 166.581 96.4233C166.297 95.0956 165.656 94.2898 164.755 94.195L164.163 94.2895ZM117.647 69.3953C118.927 59.2006 133.674 54.6959 139.459 64.0372C143.537 70.1066 141.972 79.4004 142.304 87.8407C141.64 96.7552 144.58 106.665 138.747 114.11C131.587 122.74 117.647 116.576 117.457 105.812C117.03 95.143 116.888 81.1074 117.504 70.154L117.647 69.3953ZM152.214 129.473C134.907 146.733 100.956 136.349 97.8736 112.45C97.7313 110.98 97.9684 109.842 98.7745 109.131C100.861 107.566 107.073 107.898 110.392 108.704C112.431 109.463 113.237 111.597 114.28 113.494C121.061 127.15 141.308 125.206 146.429 111.123C148.468 107.424 153.115 108.183 156.861 108.135C168.573 107.803 156.387 125.585 152.83 128.904L152.261 129.473H152.214Z"
          fill="#F9F4F1"
          stroke="#F9F4F1"
          strokeWidth="2.21413"
        />
        <rect x="57.5" y="166.111" width="1012.64" height="900.833" rx="51.1111" fill="white" />
        <text
          fill="#211217"
          style={{ whiteSpace: 'pre' }}
          xmlSpace="preserve"
          className="font-exposure"
          fontSize="63.8889"
          fontWeight="400"
          letterSpacing="-0.025em"
        >
          <tspan x="108.638" y="261.941">
            <FormattedMessage
              defaultMessage="Transcript" id="QIJsIlPJpz"
              description="Tab label in the Scribe spotlight illustration, shown on a mock document alongside 'Note' — the written record of what was said during a patient visit"
            />
          </tspan>
        </text>
        <text
          fill="#876C74"
          style={{ whiteSpace: 'pre' }}
          xmlSpace="preserve"
          className="font-exposure"
          fontSize="63.8889"
          fontWeight="400"
          letterSpacing="-0.025em"
        >
          <tspan x="515.325" y="261.941">
            <FormattedMessage
              defaultMessage="Note" id="OgdfOjeHmv"
              description="Tab label in the Scribe spotlight illustration, shown on a mock document alongside 'Transcript' — the clinical note (noun) generated from a patient visit, not a reminder or verb"
            />
          </tspan>
        </text>
        <rect x="108.611" y="313.333" width="351.389" height="25.5556" rx="12.7778" fill="#876C74" />
        <rect x="108.611" y="364.444" width="910.417" height="25.5556" rx="12.7778" fill="#D4C4C9" />
        <rect x="108.611" y="415.556" width="616.528" height="25.5556" rx="12.7778" fill="#D4C4C9" />
      </g>
      <defs>
        <clipPath id="scribe-spotlight-clip">
          <rect width="792.222" height="460" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
